import TextField from 'ageas-react-component-textfield'

import { usePaymentConfirmationStore } from '../../Stores/paymentConfirmationStore'
import { useCancelDigitalSignatureProcessStore } from '../../Stores/useCancelDigitalSignatureProcessStore'
import { useCreateProposalStore } from '../../Stores/useCreateProposalStore'
import { useFirstReceiptInfo } from '../../Stores/useFirstReceiptInfo'
import { useRefreshDigitalSignatureStatusStore } from '../../Stores/useRefreshDigitalSignatureStatusStore'
import { useRefreshFirstReceiptStatusStore } from '../../Stores/useRefreshFirstReceiptStatusStore'
import { useSubmitProposalStore } from '../../Stores/useSubmitProposalStore'
import { INVOICE_STATUS } from '../../constants/invoiceStatus'
import { t } from '../../i18n'
import { currencyFormatter } from '../../utils/currencyFormatter'
import { EmissionContainer } from './styles'
import { useStatusMessages } from './useStatusMessages'

export const EmissionResult = () => {
  const { createProposal } = useCreateProposalStore()
  const { isSignatureDigital, isFirstReceiptPaid } =
    usePaymentConfirmationStore()
  const { refreshDigitalSignatureStatus, isSigned } =
    useRefreshDigitalSignatureStatusStore()
  const { submitProposal } = useSubmitProposalStore()
  const { cancelDigitalSignatureProcess } =
    useCancelDigitalSignatureProcessStore()
  const { receiptStatusMessage } = useStatusMessages()
  const { refreshFirstReceiptStatus } = useRefreshFirstReceiptStatusStore()
  const { firstReceiptInfo } = useFirstReceiptInfo()

  const policyStatusMessageUpdate =
    refreshFirstReceiptStatus?.policySubStatusDescription?.length ||
    refreshDigitalSignatureStatus?.digitalSignature?.status ||
    isSignatureDigital ||
    isSigned

  const invoiceStatusOffer =
    (refreshFirstReceiptStatus?.invoiceStatus ||
      cancelDigitalSignatureProcess?.firstReceiptInfo?.status ||
      refreshDigitalSignatureStatus?.firstReceiptInfo?.status ||
      submitProposal?.firstReceiptInfo?.status) === INVOICE_STATUS.OFFER

  return (
    <>
      <EmissionContainer>
        <TextField
          id={'confirmation-policy-number'}
          name="confirmation-policy-number"
          label={t('pages.step7.emissionResult.policyNumber')}
          value={createProposal?.createProposalResponse?.proposalId || ''}
          colorTheme="blue"
          maxLength={70}
          version="2"
          readOnly
        />
        <TextField
          id={`confirmation-policy-state-${policyStatusMessageUpdate}-${invoiceStatusOffer}`}
          key={`confirmation-policy-state-${policyStatusMessageUpdate}-${invoiceStatusOffer}`}
          name="confirmation-policy-state"
          label={t('pages.step7.emissionResult.policyState')}
          value={
            refreshFirstReceiptStatus?.policySubStatusDescription ||
            cancelDigitalSignatureProcess?.policySubStatusDescription ||
            refreshDigitalSignatureStatus?.policyGeneralData
              ?.policySubStatusDescription ||
            submitProposal?.policySubStatusDescription ||
            ''
          }
          colorTheme="blue"
          maxLength={70}
          version="2"
          status={
            invoiceStatusOffer ||
            Boolean(
              Number(
                refreshFirstReceiptStatus?.policySubStatusDescription?.length,
              ),
            )
          }
          readOnly
        />
      </EmissionContainer>
      {(!isSignatureDigital || isSigned) && (
        <>
          <EmissionContainer>
            <TextField
              id={'confirmation-receipt-number'}
              name="confirmation-receipt-number"
              label={t('pages.step7.emissionResult.receiptNumber')}
              value={firstReceiptInfo?.invoiceId}
              colorTheme="blue"
              maxLength={70}
              version="2"
              readOnly
            />

            <TextField
              id={`confirmation-receipt-state-${isFirstReceiptPaid}-${invoiceStatusOffer}`}
              key={`confirmation-receipt-state-${isFirstReceiptPaid}-${invoiceStatusOffer}`}
              name="confirmation-receipt-state"
              label={t('pages.step7.emissionResult.receiptState')}
              value={receiptStatusMessage()}
              colorTheme="blue"
              maxLength={70}
              version="2"
              status={isFirstReceiptPaid || invoiceStatusOffer}
              readOnly
            />
          </EmissionContainer>
          <EmissionContainer>
            <TextField
              id={'confirmation-receipt-value'}
              name="confirmation-receipt-value"
              label={t('pages.step7.emissionResult.receiptValue')}
              value={currencyFormatter(firstReceiptInfo?.invoiceValue || '')}
              colorTheme="blue"
              maxLength={70}
              version="2"
              readOnly
            />
            <div />
          </EmissionContainer>
        </>
      )}
    </>
  )
}
